window.customElements.define('cart-drawer-countdown',
  class extends window.HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('initialized')) {
        return;
      }
      this.setAttribute('initialized', 'true');

      this.initializeElements();
      this.setEventListeners();

      if (localStorage.getItem(this.storageKey)) {
        this.updateCountdownUI();
        this.intervalId = setInterval(() => {
          if (!this.updateCountdownUI()) {
            clearInterval(this.intervalId);
          }
        }, 1000);
      } else {
        this.classList.add('hidden');
      }
    }

    disconnectedCallback() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
      if (this.cartChangeHandler) {
        window.removeEventListener('cart:change', this.cartChangeHandler);
      }
    }

    // Elements
    initializeElements() {
      this.countdown = this.querySelector('#cart-drawer-countdown-timer');
      this.minutes = this.dataset.minutes;
      this.storageKey = 'cartDrawerCountdown';
      this.intervalId = null;
    }

    // Event Listeners
    setEventListeners() {
      this.cartChangeHandler = (e) => {
        if (e.detail.cart.item_count > 0) {
          this.startNewCountdown();
        }
      };

      window.addEventListener('cart:change', this.cartChangeHandler);
    }

    startNewCountdown() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }

      const minutesToAdd = Number(this.minutes);
      const endDate = this.calculateEndDate(minutesToAdd);

      localStorage.setItem(this.storageKey, endDate.getTime());

      this.updateCountdownUI();
      this.intervalId = setInterval(() => {
        if (!this.updateCountdownUI()) {
          clearInterval(this.intervalId);
        }
      }, 1000);
    }

    updateCountdownUI() {
      this.classList.remove('hidden');

      const storedTime = localStorage.getItem(this.storageKey);
      if (!storedTime) return false;

      const endDate = new Date(parseInt(storedTime));
      const now = new Date();
      const difference = endDate.getTime() - now.getTime();

      if (difference <= 0) {
        this.countdown.textContent = '0:00';
        localStorage.removeItem(this.storageKey);

        this.classList.add('hidden');
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
        return false;
      }

      const minutes = Math.floor(difference / 60000);
      const seconds = Math.floor((difference % 60000) / 1000);

      this.countdown.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`;

      return true;
    }

    // Utils
    calculateEndDate(minutes) {
      const endDate = new Date();
      endDate.setMinutes(endDate.getMinutes() + minutes);
      return endDate;
    }
  });
